import React from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;

  max-width: 200px;
  min-width: 100px;
  padding: 4px 10px 6px;

  border-radius: 10px;
  border: 1px solid #313131;
  background: radial-gradient(circle, #1b2735, #090a0f);
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-sizing: border-box;
  overflow: hidden;

  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);

  &[aria-pressed="true"] {
    border-color: #6678ea;
    box-shadow:
      0 0 8px #6678ea,
      0 0 14px rgba(105, 0, 242, 0.4);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

const Label = styled.span`
  text-align: center;
  line-height: 1;
  margin-bottom: 4px;
  white-space: nowrap;
`;

const ProgressContainer = styled.div`
  position: relative;
  width: 100%;
  height: 8px;

  /* This is the 0–100% lifetime gradient */
  background: linear-gradient(
    90deg,
    #6678ea 0%,
    #6678ea 70%,
    #d6cd5d 80%,
    #f17a69 95%,
    #f17a69 100%
  );

  border-radius: 999px;
  overflow: hidden;

  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.7);
`;

const ProgressCover = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;

  width: ${({ progress }) => `${100 - progress}%`};

  background: linear-gradient(
    to left,
    #111827 0%,
    #111827 85%,
    rgba(17, 24, 39, 0.7) 92%,
    rgba(17, 24, 39, 0.0) 100%
  );

  transition: width 0.3s ease-in-out;
`;

const ProgressGlow = styled.div`
  position: absolute;
  inset: 0;
  box-shadow:
    0 0 6px rgba(102, 120, 234, 0.45),
    0 0 10px rgba(241, 122, 105, 0.25);
  pointer-events: none;
`;

const ProgressText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 9px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.7);
  pointer-events: none;
`;

function ProgressButton(props) {
  const { id, label, progress, isActive, onClick } = props;

  const clampedProgress = Math.min(100, Math.max(0, progress));

  const handleClick = () => {
    if (onClick) {
      onClick(id);
    }
  };

  return (
    <StyledButton
      type="button"
      onClick={handleClick}
      aria-pressed={isActive ? "true" : "false"}
    >
      <Label>{label}</Label>
        <ProgressContainer>
        <ProgressCover progress={clampedProgress} />
        <ProgressGlow />
        <ProgressText>{clampedProgress}%</ProgressText>
        </ProgressContainer>
    </StyledButton>
  );
}

export default ProgressButton;